module.exports = __webpack_public_path__ + "static/img/200333.6ceb2d95.png";